export const NOTIFICATION_CATEGORIES = [
  {
    key: 'conversation',
    icon: 'i-ri-chat-3-line',
    types: [
      'conversation_creation',
      'conversation_assignment',
      'assigned_conversation_new_message',
      'conversation_mention',
      'participating_conversation_new_message',
    ],
  },
  {
    key: 'sla',
    icon: 'i-ri-heart-line',
    types: [
      'sla_missed_first_response',
      'sla_missed_next_response',
      'sla_missed_resolution',
    ],
  },
  {
    key: 'ia',
    icon: 'i-ri-robot-2-line',
    types: [
      'captain_handoff',
      'captain_follow_up_due',
      'captain_runner_failure',
      'captain_paused',
      'captain_scheduling_failed',
      'captain_pending_auto_resolved',
    ],
  },
  {
    key: 'kanban',
    icon: 'i-ri-kanban-view',
    types: [
      'kanban_item_assignment',
      'kanban_item_unassignment',
      'kanban_checklist_item_assignment',
      'kanban_checklist_item_unassignment',
    ],
  },
  {
    key: 'tasks',
    icon: 'i-ri-task-line',
    types: [
      'task_assigned',
      'task_status_changed',
      'task_dependency_resolved',
      'task_mention',
    ],
  },
  {
    key: 'voip',
    icon: 'i-ri-phone-line',
    types: [
      'voip_hot_lead',
      'voip_sale_closed',
      'voip_negative_sentiment',
      'voip_critical_keyword',
      'voip_missed_hot_call',
      'voip_appointment_reminder',
      'voip_sla_violation',
    ],
  },
  {
    key: 'leads',
    icon: 'i-ri-user-star-line',
    types: ['lead_capture_form'],
  },
];

export const CATEGORY_KEYS = NOTIFICATION_CATEGORIES.map(
  category => category.key
);

export const ALL_NOTIFICATION_TYPES = NOTIFICATION_CATEGORIES.flatMap(
  category => category.types
);

export const categoryForType = type => {
  const category = NOTIFICATION_CATEGORIES.find(item =>
    item.types.includes(type)
  );
  return category ? category.key : null;
};

export const typesForCategories = (categoryKeys = []) => {
  const selected = new Set(categoryKeys);
  return NOTIFICATION_CATEGORIES.filter(category =>
    selected.has(category.key)
  ).flatMap(category => category.types);
};

const isCompleteCategorySelection = categoryKeys => {
  if (!Array.isArray(categoryKeys)) return true;
  if (categoryKeys.length !== CATEGORY_KEYS.length) return false;
  const selected = new Set(categoryKeys);
  return CATEGORY_KEYS.every(key => selected.has(key));
};

export const resolveActiveTypes = ({ categories, notificationTypes } = {}) => {
  if (categories == null || isCompleteCategorySelection(categories)) {
    return undefined;
  }

  const fromCategories = typesForCategories(categories);

  if (categories.length === 1 && Array.isArray(notificationTypes)) {
    const allowed = new Set(fromCategories);
    return notificationTypes.filter(type => allowed.has(type));
  }

  return fromCategories;
};
